import { FC, ReactNode, useLayoutEffect, useRef, useState } from 'react';

import { IonCardContent } from '@ionic/react';
import { useTheme } from 'styled-components';

import { ThemePaletteColor } from '../../../types/theme.type';

import styles from './CardThumb.module.scss';

interface CardThumbChildrenParams {
  width: number;
  height: number;
}

interface CardThumbProps {
  background?: ThemePaletteColor;
  children?: (params: CardThumbChildrenParams) => ReactNode;
}

export const CardThumb: FC<CardThumbProps> = ({
  background,
  children = () => null,
}) => {
  const [{ width, height }, setDimantions] = useState({ width: 0, height: 0 });
  const ref = useRef<HTMLIonCardContentElement>();
  const { palette } = useTheme();

  useLayoutEffect(() => {
    setTimeout(() => {
      setDimantions(() => ({
        width: ref.current.clientWidth - 32,
        height: ref.current.clientHeight - 32,
      }));
    }, 100);
  }, []);

  const vissible = width !== 0 && height !== 0;

  return (
    <IonCardContent
      ref={ref}
      className={styles.root}
      style={{ background: palette[background] }}
    >
      {vissible ? children({ width, height }) : null}
    </IonCardContent>
  );
};
